export function Notification({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0167 2.9248C7.25835 2.9248 5.01668 5.16647 5.01668 7.9248V10.3331C5.01668 10.8415 4.80001 11.6165 4.54168 12.0498L3.58335 13.6415C2.99168 14.6248 3.40001 15.7165 4.48335 16.0831C8.07501 17.2831 11.95 17.2831 15.5417 16.0831C16.55 15.7498 16.9917 14.5581 16.4417 13.6415L15.4833 12.0498C15.2333 11.6165 15.0167 10.8415 15.0167 10.3331V7.9248C15.0167 5.1748 12.7667 2.9248 10.0167 2.9248Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M11.5583 3.1667C11.3 3.0917 11.0333 3.03337 10.7583 3.00003C9.95834 2.90003 9.19167 2.95837 8.47501 3.1667C8.71667 2.55003 9.31667 2.1167 10.0167 2.1167C10.7167 2.1167 11.3167 2.55003 11.5583 3.1667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5167 16.3833C12.5167 17.7583 11.3917 18.8833 10.0167 18.8833C9.33333 18.8833 8.7 18.6 8.25 18.15C7.8 17.7 7.51666 17.0666 7.51666 16.3833"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </svg>
    </span>
  );
}
